export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quantia"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resultado"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transação"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atualizar status"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Links úteis"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blockchain:"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Em andamento"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sucesso"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Falhou"])}
}